<style scoped>
i.circle {
  width: 25px;
  height: 25px;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  display: block;
  float: left;
  margin-right: 10px;
}

span > span {
  white-space: nowrap;
  padding: 0;
}
</style>

<template>
  <span>
    <span v-if="confirmedQuantity === undefined" class="grey--text lighten-5">
      <i class="circle grey lighten-5" title="pending"></i>
    </span>
    <span v-else-if="confirmedQuantity <= 0" class="red--text">
      <i class="circle red" title="unavailable"></i>
    </span>
    <span v-else-if="confirmedQuantity == orderQuantity" class="green--text">
      <i class="circle green" title="available"></i>
    </span>
    <span v-else class="yellow--text">
      <i class="circle yellow" title="partly available"></i>
    </span>
  </span>
</template>

<script>
export default {
  props: {
    orderQuantity: {
      type: Number,
      default: 0
    },
    confirmedQuantity: {
      type: Number,
      default: undefined
    }
  }
};
</script>
